export default "__VITE_PUBLIC_ASSET__65b3a3ea__"